import React from 'react'
import CountUp, { useCountUp } from 'react-countup';

export default function OnDemandCount() {
  useCountUp({
    ref: "counter",
    start: 0,
    end: 1234567,
    delay: 1000,
    duration: 5000,
  });
  return (
    <>
      <section className="ondemand-count-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ondemand-count-head">
                <label>Quick Summary of</label>
                <h3 className="heading"><span className="gradiant-color">Mobility Infotech</span> in numbers</h3>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="ondemand-counts">
                <span><CountUp end={15} enableScrollSpy /> <small>+</small></span>
                <p>Years of Excellence</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="ondemand-counts">
                <span><CountUp end={250} enableScrollSpy /> <small>+</small></span>
                <p>Skilled IT Professionals</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="ondemand-counts">
                <span><CountUp end={1200} enableScrollSpy /> <small>+</small></span>
                <p>Satisfied Clients</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="ondemand-counts">
                <span><CountUp end={900} enableScrollSpy /> <small>+</small></span>
                <p>Project Delivered</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
